import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Params } from '@angular/router';
import { HttpService } from '../../services/http.service';
import { environment } from 'src/environments/environment';
import { IonContent, NavController } from '@ionic/angular';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { LoginService } from 'src/app/services/login.service';
import { BreadcrumbsService } from 'src/app/services/breadcrumbs.service';

@Component({
  selector: 'app-recetas',
  templateUrl: './recetas.page.html',
  styleUrls: ['./recetas.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecetasPage implements OnInit, OnDestroy {
  @ViewChild(IonContent) ionContent: IonContent;
  @ViewChild('longDescription') set longDescription(
    value: ElementRef<HTMLDivElement>
  ) {
    if (value) {
      this.largeDescriptionElement = value.nativeElement;
      this.setDescription();
    }
  }
  @ViewChild('containerProduct') containerProduct: ElementRef<HTMLDivElement>;
  public actualPage: number = 1;
  public actualPageServices = 1;
  public actualPageSubcription = 1;
  public totalPages = undefined;
  public catalogue: any = undefined;
  public catalogueSections: any[] = [];
  public domainId = environment.domainId;
  public products: any[] = [];
  public isLoad: boolean;
  public catalogueId: string;
  public ads: any[] = [];
  public slidesCatalogue: any[] = [];
  public breadcrumb: any[] = [];
  public categories: any[] = [];
  public backCategories: any[] = [];
  private _isSubscription = false;
  private _isService = false;

  public category: any = this.route.snapshot.queryParamMap.get('category');
  public categoryChild: any =
    this.route.snapshot.queryParamMap.get('hCategory');
  private _search: string = '';
  private _categorySubs: Subscription = new Subscription();
  private _subscribable: Subscription = new Subscription();
  public buyControl: any = {};
  public largeDescriptionElement: HTMLDivElement = undefined;

  constructor(
    private route: ActivatedRoute,
    private httpService: HttpService,
    private paramSv: ParamServicesService,
    private navCtrl: NavController,
    public loginSv: LoginService,
    private breadcrumbSv: BreadcrumbsService,
    private cdr: ChangeDetectorRef
  ) {
    this._subscribable.add(
      this.paramSv.reload.subscribe(async () => {
        this._categorySubs.unsubscribe();
        this.ngOnInit();
        await this.newSearch();
        await this.getCatalogue();
      })
    );
  }

  async ionViewDidEnter() {
    this.isLoad = true;
  }

  async ngOnInit() {
    try {
      if (this.paramSv.buyControl) {
        this.buyControl = this.paramSv.buyControl;
        this.fixProducts(this.products);
      } else {
        this._categorySubs.add(
          this.paramSv.emitImagesObs.subscribe((item: any) => {
            if (item.name === 'buyControl') {
              this.buyControl = this.paramSv.buyControl;
              this.fixProducts(this.products);
            } else if (item === 'finish') {
              this.cdr.detectChanges();
            }
          })
        );
      }

      this.catalogueId = this.route.snapshot.paramMap.get('id');

      this._categorySubs.add(
        this.route.paramMap.subscribe(() => {
          this.breadcrumbSv.template = [];
          if (this.catalogue)
            this.pushCrumb(undefined, this.catalogue.title, false, false);
        })
      );

      this._categorySubs.add(
        this.route.queryParamMap.subscribe(async (param: Params) => {
          if (this.category !== param.params.category) {
            this.breadcrumbSv.template.splice(1, 2);
          }

          const page = Number(param.params.pag) || 1;
          const svPag = Number(param.params.svPag) || 1;
          const subsPag = Number(param.params.subsPag) || 1;

          if (
            param.params.category === this.category &&
            param.params.chCategory === this.categoryChild &&
            page === this.actualPage &&
            svPag === this.actualPageServices &&
            subsPag === this.actualPageSubcription
          ) {
            this.actualPage = page;
            this.actualPageServices = svPag;
            this.actualPageSubcription = subsPag;
            return false;
          }

          this.category = param.params.category;
          this.categoryChild = param.params.chCategory;
          this.actualPage = page;
          this.actualPageServices = svPag;
          this.actualPageSubcription = subsPag;

          if (!this.category) {
            this.breadcrumbSv.template.splice(1, 2);
            // this.categories = this.backCategories;
            await this.newSearch();
            await this.getCatalogue();
            return true;
          }
          // this.controleCategory();
          await this.newSearch();
          await this.getCatalogue();
          if (param.params.galleryId) {
            await this.getCatalogue(param.params.galleryId);
            return;
          }
          this.cdr.markForCheck();
        })
      );

      // this.getCatalogue();
    } catch (err) {
      console.error(err);
    }
  }

  async fixProducts(products) {
    this.products = this.paramSv.fixProducts(products, this.loginSv.user);
    this.cdr.detectChanges();
  }

  setCategory(id) {
    const location = window.location.pathname;
    const queryParams: any = {
      category: Number(this.category),
    };
    if (this.category) {
      queryParams.chCategory = id;
    } else {
      queryParams.category = id;
    }
    this.navCtrl.navigateForward(location, {
      queryParams,
      queryParamsHandling: 'merge',
    });
  }

  getCategoryName(id, child) {
    let categoryName = undefined;
    if (this.categoryChild && id && child) {
      for (const item of this.backCategories) {
        const findChild = item.child.find((data) => data.id === Number(id));
        if (findChild) {
          categoryName = findChild;
          break;
        }
      }
    } else if (this.backCategories) {
      categoryName = this.backCategories.find((item) => item.id === Number(id));
    }
    return categoryName;
  }

  async getCatalogue(galleryId?) {
    try {
      const params = {
        domainId: this.domainId,
        catalogue: this.catalogueId,
        pag: this.actualPage,
        servicePage: this.actualPageServices,
        subscriptionPage: this.actualPageSubcription,
        category: this.categoryChild || this.category,
        galleryId,
      };

      const res: any = await this.httpService.getCatalogue(params);
      this.catalogueSections = res?.page;
      this._isSubscription = !!this.catalogueSections.find(
        (item) => item.type === 'subcription'
      );
      this._isService = !!this.catalogueSections.find(
        (item) => item.type === 'services'
      );
      if (this._isSubscription) {
        this.newSearch();
      }
      if (this._isService) {
        this.newSearch();
      }
      this.categories = this.catalogueSections.find(
        (item) => item.type === 'categories'
      )?.categories;

      this.backCategories = this.categories;
      if (!this.catalogue) {
        this.catalogue = res.catalogue;
        this.catalogue.description =
          this.catalogue.description === 'null'
            ? null
            : this.catalogue.description;
        this.slidesCatalogue = this.catalogue.media;
        this.pushCrumb(undefined, this.catalogue.title, false, false);
      } else {
        this.catalogue.longDescription = res.catalogue.longDescription;
        this.setDescription();
      }
      this.controleCategory();
    } catch (err) {
      console.error(err);
    }
  }

  setDescription() {
    if (this.largeDescriptionElement) {
      this.largeDescriptionElement.innerHTML = this.catalogue.longDescription;
      this.cdr.detectChanges();
    }
  }

  setGalleryId(galleryId) {
    this.getCatalogue(galleryId);
  }

  controleCategory() {
    if (this.category) {
      const category = this.getCategoryName(this.category, false);
      if (category) {
        this.pushCrumb(this.category, category?.name, false, true);
        this.categories = category.child;
      }
    }
    if (this.categoryChild) {
      const category = this.getCategoryName(this.categoryChild, true);
      if (category) {
        this.pushCrumb(this.categoryChild, category?.name, true, true);
        this.categories = category.child;
      }
    }
    this.cdr.detectChanges();
  }

  pushCrumb(id, name, isChild, haveId) {
    this.breadcrumbSv.pushCrumb(id, name, isChild, haveId);
    this.cdr.markForCheck();
  }

  async newSearch() {
    return new Promise(async (resolve, reject) => {
      try {
        this.httpService.loadingIndicatorSrc.next(true);
        const catalogue: any = await this.httpService.catalogues(
          this.domainId,
          this.catalogueId,
          this.actualPage,
          this._search,
          this.category,
          this.categoryChild,
          this._isSubscription,
          this._isService
        );
        const catalogueDataProduct =
          catalogue.data.product || catalogue.data.products;
        const products = catalogueDataProduct.data;
        this.totalPages = catalogueDataProduct.meta.last_page;
        this.ads = catalogue.data.ads;
        await this.fixProducts(products);
        this.httpService.loadingIndicatorSrc.next(false);
        resolve(true);
      } catch (err) {
        console.error(err);
        reject(false);
      }
    });
  }

  async upPage(toPage, type: 'product' | 'services' | 'subcription') {
    console.log('toPage :>> ', toPage);
    console.log('type :>> ', type);
    this.navCtrl.navigateRoot([], {
      queryParams: {
        pag: type === 'product' ? toPage : this.actualPage,
        svPag: type === 'services' ? toPage : this.actualPageServices,
        subsPag: type === 'subcription' ? toPage : this.actualPageSubcription,
      },
      queryParamsHandling: 'merge',
    });
    // await this.ionContent.scrollToTop(500);
  }

  ngOnDestroy(): void {
    this._subscribable.unsubscribe();
  }
}
